module.exports = __webpack_public_path__ + "static/media/product_gmc.0ba6cd84.svg";